import { Spinner } from 'ui/spinner';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const EmptyStateContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: ${pxToRem(500)};
  justify-content: center;
  text-align: center;
`;

type Props = {
  isLoading: boolean;
  children?: React.ReactNode;
};

export const LOADING_TEST_ID = 'mobileApps-EmptyState--Loading';
export const EMPTY_TEST_ID = 'mobileApps-EmptyState--Empty';

export const EmptyState = ({ isLoading, children }: Props) => {
  const DATA_TEST_ID = isLoading ? LOADING_TEST_ID : EMPTY_TEST_ID;
  return (
    <EmptyStateContainer data-test={DATA_TEST_ID}>
      {isLoading ? <Spinner /> : children}
    </EmptyStateContainer>
  );
};
